exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discussion-ButtonAdd-Root {\n  margin: 0 60px 40px;\n  cursor: pointer;\n  background-color: #2c75e7;\n  border-radius: 3px;\n  box-sizing: border-box;\n  padding: 15px;\n}\n@media (max-width: 480px) {\n  .Discussion-ButtonAdd-Root {\n    margin: 0 20px 30px;\n  }\n}\n.Discussion-ButtonAdd-Label {\n  color: #fff;\n  font-size: 14px;\n  font-weight: bold;\n  line-height: 18px;\n  text-align: center;\n  text-transform: uppercase;\n}\n", ""]);

// exports
